// ¿Está el que mira pegado al final de la conversación?
//
// El chat bajaba al último mensaje cada vez que llegaba un snapshot de
// Firestore, y el listener devuelve un array nuevo aunque no haya cambiado
// nada. Resultado: si te ibas hacia arriba a releer algo, la pantalla te
// devolvía abajo sola. Ahora solo baja si ya estabas abajo.

export const MARGEN_ABAJO = 80;

export type Caja = { scrollTop: number; scrollHeight: number; clientHeight: number };

export function pegadoAbajo(el: Caja | null | undefined, margen = MARGEN_ABAJO): boolean {
  // Sin caja todavía (primer pintado) se considera que sí: al abrir un chat
  // hay que bajar.
  if (!el) return true;
  return el.scrollHeight - el.scrollTop - el.clientHeight <= margen;
}
